import { styled, Box, Stack, Typography } from '../../../../base';

export const StyledTop3Row = styled(Stack)(({ theme }) => ({
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
}));

export const StyledTop3Card = styled(Stack)(({ theme }) => ({
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    flex: '1 1 0',
    minWidth: 220,
    paddingInlineEnd: theme.spacing(2),
    '&:not(:last-of-type)': {
        borderInlineEnd: `1px solid ${theme.palette.divider}`,
    },
    [theme.breakpoints.down('lg')]: {
        '&:not(:last-of-type)': {
            borderInlineEnd: 'none',
        },
    },
}));

export const StyledIconCircle = styled(Box)(({ theme }) => ({
    borderRadius: '50%',
    background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    width: 45,
    flexShrink: 0,
    boxShadow: theme.shadows[3],
}));

export const StyledCardTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[500],
    fontWeight: 700,
}));

export const StyledRankList = styled(Box)(({ theme }) => ({
    listStyle: 'none',
    margin: theme.spacing(0.5, 0, 0),
    padding: 0,
}));

export const StyledRankItem = styled(Stack)(({ theme }) => ({
    gap: theme.spacing(0.5),
    color: theme.palette.grey[700],
}));
